export const staleTime = 300000; // 5 minutes
export const cacheTime = 300000; // 5 minutes
export const longStaleTime = 1800000; // 30 minutes
export const extraLongStaleTime = 14400000; // 4 hours
export const DEFAULT_PAGE_SIZE = 10;
